// @flow strict
import React from 'react'

import DefaultFooter from './DefaultFooter'

export default function MonzoPremiumFooter() {
  return (
    <DefaultFooter
      altLinks={{
        termsAndConditions: {
          label: 'Terms & Conditions',
          href: '/legal/premium/terms-and-conditions/',
        },
      }}
    />
  )
}
